import React from 'react';


export default function HomeAnnotationTemplate(annotation) {
    const data = annotation.data;
    return (
        <svg className="annotation"  >

            <text className="capital" onClick={() => { annotation.onClick(data) }} >
                {
                    data.domainName.length > 20 ? data.domainName.slice(0, 20) + "..." : data.domainName

                }
                <tspan className="capital" dx="5">({data.count})</tspan>
            </text>

            {/* <text>
       
       <tspan className="capital" >{data.domainName.slice(0,20)}</tspan> 

       <tspan className="capital" dx="7"> ({data.count})  </tspan>
       <tspan dy="14" x="0" className="caption">Population:</tspan>
       <tspan className="capital" dx="5">{data.count}</tspan>
       </text> */}

            {/* <text x="70" y="25" className="state">{annotation.argument}</text>
            <text x="0" y="60">
                <tspan className="caption">Capital:</tspan>
                <tspan className="capital" dx="5">{data.count}</tspan>
                <tspan dy="14" x="0" className="caption">Population:</tspan>
                <tspan className="population" dx="5">{data.sicilNo}</tspan>
                <tspan dy="14" x="0" className="caption">Area:</tspan>
                <tspan className="area" dx="5">{data.area}</tspan>
                <tspan dx="5">km</tspan>
                <tspan className="sup" dy="-2">2</tspan>
            </text> */}




        </svg>
    );
}
